import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { HttpLoaderService } from '@tymes4-shared';
import { IPWhitelistingService } from '../../api';

@Component({
    selector: 'app-edit-ip-whitelisting-form',
    templateUrl: './edit-ip-whitelisting-form.component.html',
    styleUrls: ['./edit-ip-whitelisting-form.component.scss'],
    standalone: false
})
export class EditIpWhitelistingComponent implements OnInit {

  public form: FormGroup;

  public editingObject = null;
  private isNew = false;
  public saving = false;
  public pricecomponents: any;

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              public dialogRef: MatDialogRef<EditIpWhitelistingComponent>,
              private loader: HttpLoaderService,
              private ipWhitelistingService: IPWhitelistingService
              ) { }

  validationMessages = {
    'IPAddress': [
      { type: 'pattern', message: 'FORM.VALIDATION.INVALIDIP' }
    ],
  };

  ngOnInit() {
    this.editingObject = this.passedData.payload;
    this.isNew = this.editingObject == null;
    this.editingObject = this.editingObject ?? {};

    this.form = new FormGroup({
      Id: new FormControl(0), // to preserve value
      IPAddress: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/)
      ]),
      Description: new FormControl(''),
    });

    this.form.patchValue(this.editingObject);
  }

  submit() {
    const formData = this.form.value;

    this.loader.open();

    if (this.isNew === true) {
      this.ipWhitelistingService.createIPWhiteListing(formData).subscribe((id: number) => {
        this.loader.open();
        this.dialogRef.close(id);
      });
    }
    else {
      this.ipWhitelistingService.updateIPWhiteListing(formData).subscribe((id: number) => {
        this.loader.open();
        this.dialogRef.close(id);
      });
    }
  }
}
